// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"FaqsPage_sectionContent__3F3XB","title":"FaqsPage_title__3leLH","list":"FaqsPage_list__GXr_O","sectionWhite":"FaqsPage_sectionWhite__2XQ5o"};